module.exports = __webpack_public_path__ + "static/stocktoflow-4f53bc80e252b7c0107dbf175dbfd99a.png";